import { useMemo } from 'react';

import { getPartnerTypePCode } from 'src/utils/getPartnerTypePCode';
import { CVR_TREATS_IN_CHECKOUT_UI } from '../../abTesting/features';
import { useFeature } from '../../abTesting';
import type { CvrTreatsInCheckoutUiTreatments } from '@farmersdog/tosa/src/utils';

export interface UseTreatsInCheckoutUiReturn {
  shouldShowTreatsPage: boolean;
  shouldShowTreatsOnCheckoutPage: boolean;
}

export function useTreatsInCheckoutUi(): UseTreatsInCheckoutUiReturn {
  const pcode = getPartnerTypePCode();

  const { treatment } = useFeature<CvrTreatsInCheckoutUiTreatments>(
    CVR_TREATS_IN_CHECKOUT_UI,
    {
      attributes: { pcode },
    }
  );

  const shouldShowTreatsPage = treatment === 'page';

  return useMemo(
    () => ({
      shouldShowTreatsPage,
      shouldShowTreatsOnCheckoutPage: !shouldShowTreatsPage,
    }),
    [shouldShowTreatsPage]
  );
}
